// @flow

import PrimaryPalette, { type Color } from '../../colors';

type ButtonThemeState = {|
  color: Color,
  iconColor: Color,
  borderColor: Color,
  backgroundColor: Color,
|};

type TertiaryButtonThemeState = {|
  color: Color,
|};

type ButtonTheme = {|
  loadingSpinnerFlavor: string,
  default: ButtonThemeState,
  hover: {|
    ...ButtonThemeState,
    dropShadowOpacity: number,
  |},
  active: {|
    ...ButtonThemeState,
  |},
|};

type TertiaryButtonColorTheme = {|
  default: TertiaryButtonThemeState,
  hover: TertiaryButtonThemeState,
|};

const lightShadowOpacity = 0.13;
const darkShadowOpacity = 0.3;

const PrimaryButtonTheme = {
  loadingSpinnerFlavor: 'pale',
  default: {
    color: PrimaryPalette.white,
    borderColor: PrimaryPalette.mediumIris,
    backgroundColor: PrimaryPalette.mediumIris,
    iconColor: PrimaryPalette.white,
  },
  hover: {
    color: PrimaryPalette.white,
    borderColor: PrimaryPalette.darkIris,
    backgroundColor: PrimaryPalette.darkIris,
    dropShadowOpacity: darkShadowOpacity,
    iconColor: PrimaryPalette.white,
  },
  active: {
    color: PrimaryPalette.white,
    borderColor: PrimaryPalette.darkIris,
    backgroundColor: PrimaryPalette.darkIris,
    iconColor: PrimaryPalette.white,
  },
};

const SecondaryButtonTheme = {
  loadingSpinnerFlavor: 'green',
  default: {
    color: PrimaryPalette.darkGreen,
    borderColor: PrimaryPalette.darkGreen,
    backgroundColor: PrimaryPalette.white,
    iconColor: PrimaryPalette.darkGreen,
  },
  hover: {
    color: PrimaryPalette.mediumEvergreen,
    borderColor: PrimaryPalette.mediumEvergreen,
    backgroundColor: PrimaryPalette.white,
    dropShadowOpacity: lightShadowOpacity,
    iconColor: PrimaryPalette.mediumEvergreen,
  },
  active: {
    color: PrimaryPalette.mediumEvergreen,
    borderColor: PrimaryPalette.mediumEvergreen,
    backgroundColor: PrimaryPalette.lightestGrey,
    iconColor: PrimaryPalette.mediumEvergreen,
  },
};

const DangerButtonTheme = {
  loadingSpinnerFlavor: 'poppy',
  default: {
    color: PrimaryPalette.mediumPoppy,
    borderColor: PrimaryPalette.mediumPoppy,
    backgroundColor: PrimaryPalette.white,
    iconColor: PrimaryPalette.mediumPoppy,
  },
  hover: {
    color: PrimaryPalette.darkPoppy,
    borderColor: PrimaryPalette.darkPoppy,
    backgroundColor: PrimaryPalette.white,
    dropShadowOpacity: lightShadowOpacity,
    iconColor: PrimaryPalette.darkPoppy,
  },
  active: {
    color: PrimaryPalette.darkPoppy,
    borderColor: PrimaryPalette.darkPoppy,
    backgroundColor: PrimaryPalette.lightestGrey,
    iconColor: PrimaryPalette.darkPoppy,
  },
};

const TertiaryButtonTheme = {
  default: { color: PrimaryPalette.darkGreen },
  hover: { color: PrimaryPalette.mediumGreen },
};

const DangerTertiaryButtonTheme = {
  default: { color: PrimaryPalette.mediumPoppy },
  hover: { color: PrimaryPalette.lightPoppy },
};

export {
  PrimaryButtonTheme,
  SecondaryButtonTheme,
  DangerButtonTheme,
  TertiaryButtonTheme,
  DangerTertiaryButtonTheme,
};

export type { ButtonTheme, TertiaryButtonColorTheme };
